export class ReportNotFoundError {

};
